import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class MandateContainer extends ShadowDOMElement {
	static className = "MandateContainer";
	
	render() {
    return html`
      <div>
        <row-wrapper>
          <radio-buttons-field
            name="mandate-choice"
            .options="${[
              { title: 'Oui', value: 'oui' },
              { title: 'Non', value: 'non' },
            ]}"
            value="oui"
            @change="${this.handleRadioChange}"
          ></radio-buttons-field>
        </row-wrapper>
        <div-container>
          <row-with-tooltip tooltip-text="Utiliser le texte existant, le modifier ou le compléter si nécessaire.">
            <text-area-field label="Mandat *" value="Le mandat des commissaires aux comptes ne se poursuit pas." name="mandate"></text-area-field>
          </row-with-tooltip>
        </div-container>
      </div>
    `;
	}

	handleRadioChange(event) {
		const selectedValue = event.detail?.value;
		const divContainer = this.shadowRoot.querySelector ("div-container");
		
		if (divContainer && selectedValue)
			divContainer.visible = selectedValue === 'oui';
	}
}

customElements.define('mandate-container', MandateContainer);
